import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'H&L Cloud - Pay at Table',
  saveSuccess: 'Venue sites configuration saved successfully.',
})
